module.exports = __webpack_public_path__ + "static/media/IUP_zast_L3.7a9032ee.svg";